import { BodySmallText } from '@prisjakt/ui/text/variants';
import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const HighlightedOfferPanel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  background: ${props => props.theme.bg.secondary};
  border-radius: 16px;
`;
export const HighlightedOfferColumn = styled.div``;

export const OfferHeader = styled.div`
  margin-bottom: 0.5rem;
  ${media.mediumUp`
    text-align: center;
    margin-bottom: 1rem;
  `};
`;
export const OfferHeading = styled.h3`
  ${media.smallOnly`
    font-size: 0.85rem;
    margin-bottom: 0;
  `};
`;
export const OfferHeadingSubTitle = styled(BodySmallText)`
  ${media.smallOnly`
    display: none;
  `};
`;
